import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Space,
  Input,
  Form,
  Radio,
  Select,
  message,
  notification,
} from "antd";
import { Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "../css/product.css";
import axios from "axios";
import { path, src } from "../network/conn";
import { EditFilled } from "@ant-design/icons";
import { OmitProps } from "antd/lib/transfer/ListBody";
const key = "updatable";
const openMessageLoading = (load) => {
  message.loading({ content: load, key });
};
const openMessageSuccess = (loaded) => {
  message.success({ content: loaded, key, duration: 2 });
};
const Masterdoctor = (props) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataSource, setdataSource] = useState([]);
  const [size, setSize] = useState();
  const [totalRecord, settotalRecord] = useState(0);
  const [submitType, setsubmitType] = useState("insert");
  const [userSetting,setUserSetting] = useState({});
  const [form] = Form.useForm();
  const logUser = window.sessionStorage.getItem("user");
 const {Option}=Select;
  const adddoctor = () => {
    setsubmitType("insert");
    fetchCount();
    showLargeDrawer();
  };
  const showLargeDrawer = () => {
    setSize("large");
    setVisible(true);
  };
  const drawerClose = () => {
    setVisible(false);
    form.resetFields();
  };
  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 10 },
  };
  const onFinish = (e) => {
    const data = e;
    data['user'] = logUser;
    openMessageLoading("Adding doctor", 20);
    let BaseURL = path + src + "insertdoctor.php";
    axios
      .post(BaseURL, data)
      .then((response) => {
        openMessageSuccess(response.data, 20);
        drawerClose();
        fetchTableData();
        props.onScanDataReload();
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };

  const fetchTableData = () => {
    setLoading(true);
    let BaseURL = path + src + "doctorlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setdataSource(response.data);
        settotalRecord(response.data.length);
        drawerClose();
        setLoading(false);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchCount = () => {
        let value = dataSource.length + 1 ; 
        let valueStr = "0000"+ value.toString();
        settotalRecord(dataSource.length);
        form.setFieldsValue({
          code: "DOC-" + (valueStr.substr(-4)),
          submit: "insert",
        });
  };
  const onEditdoctor = (record) => {
    setsubmitType("update");
    console.log(submitType);
    showLargeDrawer();
    let response = dataSource.filter((list)=>{return list.code == record.code});
      form.setFieldsValue({
        code      : record.code,
        doctor    : response[0].doctor,
        date      : response[0].date,
        time      : response[0].time,
        hospital  : response[0].hospital,
        //extra:response[0].commision,
       
        submit: "update",
      })
  };
  const profile = window.sessionStorage.getItem("profile");
  const fetch_profile_permission = (profile) =>{
    console.log('profile',profile);
    let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
    axios
    .get(BaseURL)
      .then((response) => {
        console.log(response.data);
        let dataObj = {};
        response.data.map((list)=>{
          let permissionObj = {};
          if(list.filename == 'masterdoctor'){
          permissionObj['add']      = list.add;
          permissionObj['edit']     = list.edit;
          permissionObj['delete']   = list.delete;
          permissionObj['show']     = list.show;
          permissionObj['print']    = list.print;
          permissionObj['excel']    = list.excel;
          permissionObj['profile']  = list.profile;
          dataObj[list.filename]    =  permissionObj;
          setUserSetting(permissionObj);
          }
        })
       
       console.log('dataObj',dataObj);
      })
      .catch((error) => {
        //openMessageSuccess(error, 10);
        console.log(error);
      });
    }
  useEffect(() => {
    fetchTableData();
    fetch_profile_permission(profile);
  }, []);
  const columns = [
    {
      key: "1",
      title: "Sno",
      dataIndex: "sno",
      sorter: (record1, record2) => {
        return record1.id > record2.id;
      },
    },
    {
      key: "2",
      title: "Code",
      dataIndex: "code",
    },
    {
      key: "3",
      title: "Doctor",
      dataIndex: "doctor",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.doctor.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "4",
      title: "Hospital",
      dataIndex: "hospital",
    },
    {
      key: "6",
      title: "Edit",
      render: (record) => (
       Number(userSetting.edit) == 1 ? <Button
          title="Edit"
          size="small"
          type="primary"
          onClick={() => {
            onEditdoctor(record);
          }}
        >
          <EditFilled />
        </Button> :''
      ),
    },
    // {
    //   key: "7",
    //   title: "Delete",
    //   render: (record) => (
    //     <Button
    //       title="Edit"
    //       size="small"
    //       type="danger"
    //       onClick={() => {
    //         openNotification(record);
    //       }}
    //     >
    //       Delete
    //     </Button>
    //   ),
    // },
  ];

  return (
    <>
      <Space>
       {Number(userSetting.add) == 1 ?  <Button type="primary" onClick={adddoctor}>
          Add Doctor +
        </Button>  : '' }
      </Space>
      <Modal
        title={submitType == "insert" ? "Add doctor" : "Edit doctor"}
        style={{ top: 20 }}
        visible={visible}
        onOk={() => drawerClose()}
        onCancel={() => drawerClose()}
        width={"90vw"}
        maskClosable={false}
        footer={null}
      >
        <Form {...layout} form={form} name="nest-messages" onFinish={onFinish}>
          <Form.Item
            name="code"
            label="Code"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Your Code" autocomplete="off" disabled = {true} style={{color:"red"}} />
          </Form.Item>
          <Form.Item name="doctor" label="Doctor" rules={[{ required: true }]}>
            <Input placeholder="doctor Name" autocomplete="off" />
          </Form.Item>
          <Form.Item name="hospital" label="Hospital" rules={[{ required: false }]}>
            <Input placeholder="Hospital Name" autocomplete="off" />
          </Form.Item>
          {/* <Form.Item
            name="shift"
            label="Shift"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select Shift"
                >
              
                <Option value="Day">Day</Option>
                <Option value="Aftn">Afternoon</Option>
                <Option value="Night">Night</Option>
            </Select>
          </Form.Item> */}
          {/* <Form.Item
            name="extra"
            label="Commision"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Your commission Percent" autocomplete="off" />
          </Form.Item> */}
          <Form.Item
            name="submit"
            label="sumit"
            value={submitType}
            rules={[{ required: false }]}
            hidden={true}
          >
            <Input placeholder="Submit" autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="date"
            label="submit"
            rules={[{ required: false }]}
            hidden={true}
          >
            <Input placeholder="Submit" autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="time"
            label="sumit"
            rules={[{ required: false }]}
            hidden={true}
          >
            <Input placeholder="Submit" autocomplete="off" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {submitType == "insert" ? "Submit" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Table
        bordered
        className="tableData"
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 5, total: { totalRecord } }}
      ></Table>
    </>
  );
};
export default Masterdoctor;
